export const FIREBASE_AUTH = {
    LOAD: 'FIREBASE_AUTH_LOAD',
    FAIL: 'FIREBASE_AUTH_FAIL',
    SUCCESS: 'FIREBASE_AUTH_SUCCESS'
}